import Button from "../../base/Button";

const renderIcon = (color) => (
    <svg width="22px" height="25px" viewBox="0 0 22 25" version="1.1">
        <title>align-left</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Lightsmap-2.0"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
        >
            <g
                id="Select-Manual"
                transform="translate(-159.000000, -71.000000)"
                stroke={color}
            >
                <g id="toolbar" transform="translate(0.000000, 60.000000)">
                    <g
                        id="Group-11"
                        transform="translate(143.800000, 11.500000)"
                    >
                        <g
                            id="align-left"
                            transform="translate(15.500000, 0.000000)"
                        >
                            <path
                                d="M0.413793103,0.413793103 L0.413793103,23.5862069"
                                id="Shape"
                            />
                            <rect
                                id="Rectangle-path"
                                x="5.37931034"
                                y="3.72413793"
                                width="14.8965517"
                                height="5.79310345"
                            />
                            <rect
                                id="Rectangle-path"
                                x="5.37931034"
                                y="14.4827586"
                                width="7.44827586"
                                height="5.79310345"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

/**
 * Toolbar button for aligning selected lights to the left.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered align left button.
 */
const AlignLeftButton = (props) => (
    <Button {...props} renderIcon={renderIcon} />
);

export default AlignLeftButton;
